import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ArrowRight, Home } from 'lucide-react';

const NotFoundPage = () => {
  const { i18n } = useTranslation();
  const isArabic = i18n.language === 'ar';

  return (
    <div
      className="min-h-screen flex flex-col items-center justify-center px-4 text-center"
      style={{ background: '#F9F7F4' }}
      dir={isArabic ? 'rtl' : 'ltr'}
    >
      <div className="max-w-xl mx-auto">
        <p className="text-8xl font-black mb-4" style={{ color: '#A27849', letterSpacing: '-0.04em' }}>
          404
        </p>

        <h1 className="text-2xl md:text-3xl font-bold mb-3" style={{ color: '#1F3B64' }}>
          {isArabic ? 'الصفحة غير موجودة' : 'Page Not Found'}
        </h1>

        <p className="text-gray-500 mb-8 leading-relaxed">
          {isArabic
            ? 'الرابط الذي أدخلته غير صحيح أو تمت إزالة الصفحة. يمكنك العودة للصفحة الرئيسية.'
            : 'The page you are looking for does not exist or has been removed. You can return to the homepage.'}
        </p>

        <Link
          to="/"
          className="inline-flex items-center gap-2 px-8 py-4 rounded-xl font-bold text-white transition-all hover:opacity-90"
          style={{ background: '#1F3B64' }}
        >
          <Home className="w-5 h-5" />
          <span>{isArabic ? 'الصفحة الرئيسية' : 'Go to Homepage'}</span>
          <ArrowRight className={`w-5 h-5 ${isArabic ? 'rotate-180' : ''}`} />
        </Link>
      </div>
    </div>
  );
};

export default NotFoundPage;
